import { useNavigate } from 'react-router-dom'
import { Card } from '@/components/ui/Card'
import { StatusBadge } from '@/components/ui/StatusBadge'
import type { SessionSummary } from '@/api/interview'

interface Props {
  sessions: SessionSummary[]
  total: number
  page: number
  pageSize: number
  onPageChange: (page: number) => void
}

export function SessionsTable({ sessions, total, page, pageSize, onPageChange }: Props) {
  const navigate = useNavigate()
  const totalPages = Math.ceil(total / pageSize)

  return (
    <Card>
      <div style={{ overflowX: 'auto' }}>
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Job Title</th>
              <th>Company</th>
              <th>Language</th>
              <th>Status</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {sessions.length === 0 ? (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center', opacity: 0.5 }}>
                  No sessions
                </td>
              </tr>
            ) : (
              sessions.map((s) => (
                <tr key={s.id}>
                  <td className="font-mono">{s.id}</td>
                  <td>{s.job_title}</td>
                  <td>{s.company_name}</td>
                  <td>{s.language.toUpperCase()}</td>
                  <td><StatusBadge status={s.status} /></td>
                  <td>{new Date(s.created_at).toLocaleString('de-DE')}</td>
                  <td>
                    <button
                      className="btn btn--sm btn--outline"
                      onClick={() => navigate(`/dashboard/session/${s.id}`, { state: { session: s } })}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <button
          className="btn btn--sm btn--outline"
          disabled={page === 0}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </button>
        <span className="pagination-info">
          Page {page + 1} of {totalPages || 1} — {total} total
        </span>
        <button
          className="btn btn--sm btn--outline"
          disabled={page + 1 >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </Card>
  )
}